import { Reveal, Overline } from "./Reveal";
import { Placeholder } from "./Placeholder";
import { ArrowRight } from "lucide-react";

export const Showcase = ({
  id,
  no,
  overline,
  title,
  body,
  bullets = [],
  images = [],
  gallery = [],
  reverse = false,
  tinted = false,
  testId,
}) => {
  const single = images.length === 1;

  return (
    <section
      id={id}
      data-testid={testId}
      className={`py-24 md:py-36 ${tinted ? "bg-surface/40 border-y border-line/40" : ""}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-24 items-center">
        {/* Media */}
        <Reveal className={reverse ? "lg:order-2" : "lg:order-1"}>
          {single ? (
            <Placeholder
              src={images[0].src}
              label={images[0].label}
              className="aspect-[3/4] w-full"
              parallax
              testId={`${testId}-img-0`}
            />
          ) : (
            <div className="grid grid-cols-2 gap-4 md:gap-5">
              <Placeholder
                src={images[0].src}
                label={images[0].label}
                className="aspect-[3/4] w-full"
                parallax
                testId={`${testId}-img-0`}
              />
              <Placeholder
                src={images[1].src}
                label={images[1].label}
                className="aspect-[3/4] w-full"
                parallax
                testId={`${testId}-img-1`}
              />
            </div>
          )}
        </Reveal>

        {/* Copy */}
        <Reveal delay={0.12} className={reverse ? "lg:order-1" : "lg:order-2"}>
          <div className="flex items-center gap-4 mb-6">
            <span className="font-mono text-sm text-primary/70">{no}</span>
            <span className="h-px w-10 bg-line" />
            <Overline>{overline}</Overline>
          </div>
          <h2 className="font-serif font-light tracking-tight leading-[0.95] text-textMain text-4xl md:text-5xl lg:text-6xl">
            {title}
          </h2>
          <p className="font-sans text-textMuted leading-relaxed mt-8 max-w-xl">{body}</p>

          {bullets.length > 0 && (
            <ul className="mt-10 grid sm:grid-cols-2 gap-x-8 border-t border-line/60">
              {bullets.map((b) => (
                <li
                  key={b}
                  className="flex items-center gap-3 py-4 border-b border-line/60 group"
                >
                  <ArrowRight className="w-4 h-4 text-primary/60 shrink-0 group-hover:translate-x-1 transition-transform" strokeWidth={1.5} />
                  <span className="font-sans text-[15px] text-textMain/85">{b}</span>
                </li>
              ))}
            </ul>
          )}
        </Reveal>
      </div>

      {gallery.length > 0 && (
        <div className="max-w-7xl mx-auto px-6 md:px-12 mt-8 md:mt-12">
          <div className={`grid grid-cols-2 gap-4 md:gap-5 ${
            { 2: "md:grid-cols-2", 3: "md:grid-cols-3", 4: "md:grid-cols-4" }[
              [4, 3, 2].find((c) => gallery.length % c === 0) || 4
            ]
          }`}>
            {gallery.map((g, i) => (
              <Reveal key={i} delay={Math.min(i * 0.06, 0.3)} y={20}>
                <Placeholder
                  src={g.src}
                  label={g.label}
                  className="aspect-[3/4] w-full"
                  parallax
                  testId={`${testId}-gallery-${i}`}
                />
              </Reveal>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
